import { TapTableView } from "../components/orders/TapTableView";

export const TapPage = () => <TapTableView defaultMode="tap" />;

export default TapPage;
